import { useEffect } from "react";
import { SHA3 } from "sha3";
import { getSessionItem } from "src/utils/SessionManagement";

const hash = (value: string) => new SHA3(256).update(value).digest({ format: "hex" });

export const MEASUREMENT_ID = "G-B59F6C9222";
// https://developers.google.com/tag-platform/gtagjs/reference
export const GaConfig = () => {
  const email = getSessionItem("email");
  useEffect(() => {
    if (email) {
      const hashedEmail = hash(email?.toLowerCase() ?? "");
      window.gtag("set", {
        user_id: hashedEmail,
      });

      // Send data on every event
      // user_id is reserved so we need to set our own parameter for tracking in reports
      window.gtag("set", "user_properties", {
        user_email_hash: hashedEmail,
      });
    }
  }, [email]);

  return null;
};
